// src/utils/weekUtils.js
// Pomoćne funkcije za rad s tjednima u godini

const DAY_NAMES = ['PON', 'UTO', 'SRI', 'ČET', 'PET', 'SUB', 'NED'];

/**
 * Vraća ponedjeljak tjedna koji sadrži dan
 */
export function getMondayOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}

/**
 * Vraća sve tjedne u godini (ponedjeljak-nedjelja)
 * Tjedan 1 = tjedan koji sadrži 4. siječnja
 */
export function getWeeksInYear(year) {
  const weeks = [];
  const jan4 = new Date(year, 0, 4);
  const firstMonday = getMondayOfWeek(jan4);

  let currentMonday = new Date(firstMonday);
  const endOfYear = new Date(year, 11, 31);

  let weekIndex = 0;
  while (currentMonday.getFullYear() <= year) {
    const dates = [];
    for (let d = 0; d < 7; d++) {
      const date = new Date(currentMonday);
      date.setDate(currentMonday.getDate() + d);
      dates.push({
        date,
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
        dayOfWeek: d,
        dayName: DAY_NAMES[d],
      });
    }
    weeks.push({
      weekIndex,
      startDate: new Date(currentMonday),
      dates,
      label: `T${weekIndex + 1}`,
    });
    currentMonday.setDate(currentMonday.getDate() + 7);
    weekIndex++;
    if (currentMonday > endOfYear) break;
  }

  return weeks;
}

/**
 * Vraća indeks prošlog tjedna (tjedan prije trenutnog)
 */
export function getPreviousWeekIndex() {
  const now = new Date();
  const monday = getMondayOfWeek(now);
  const jan4 = new Date(now.getFullYear(), 0, 4);
  const firstMonday = getMondayOfWeek(jan4);
  const diffMs = monday - firstMonday;
  const diffWeeks = Math.floor(diffMs / (7 * 24 * 60 * 60 * 1000));
  return Math.max(0, diffWeeks - 1);
}

/**
 * Vraća indeks trenutnog tjedna
 */
export function getCurrentWeekIndex(year) {
  const now = new Date();
  const currentYear = now.getFullYear();
  if (year !== currentYear) return 0;
  const monday = getMondayOfWeek(now);
  const jan4 = new Date(currentYear, 0, 4);
  const firstMonday = getMondayOfWeek(jan4);
  const diffMs = monday - firstMonday;
  return Math.max(0, Math.floor(diffMs / (7 * 24 * 60 * 60 * 1000)));
}

/**
 * Indeksi tjedana (polje iz getWeeksInYear) koji imaju barem jedan dan u danom kalendarskom mjesecu.
 * Mjesec može imati 4–6 takvih tjedana.
 */
export function getWeekIndicesForCalendarMonth(weeks, year, month) {
  if (!weeks || month < 1 || month > 12) return [];
  const indices = [];
  weeks.forEach((w, i) => {
    const touches = w.dates.some((d) => d.year === year && d.month === month);
    if (touches) indices.push(i);
  });
  return indices;
}

export { DAY_NAMES };
